module.exports = __webpack_public_path__ + "img/message.0b67bc52.png";